var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.order)?_c('div',{staticClass:"download-order"},[_c('a',{attrs:{"href":"#","title":"Download Order to Excel"},on:{"click":function($event){$event.preventDefault();return _vm.downloadCSVOrder()}}},[_c('img',{attrs:{"src":require("@/assets/images/excel-download1x.png"),"alt":"Download to Excel"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }